import * as ES6Promise from 'es6-promise';
import 'bootstrap';
import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'simplebar';
import { Amplitude } from './Scripts/Shared/amplitude';
import { Navigation } from './Scripts/Shared/navigation';

import 'normalize.css';
import './styles.scss';
import './Styles/Shared/shared.scss';

import './Scripts/Home/home';

import ModalDialog from './Scripts/Components/modal-dialog';

ES6Promise.polyfill();

(window as any).jQuery = (window as any).$ = $;

Amplitude.init();

$(() => {
	Navigation.start();

	Amplitude.identify();

	Amplitude.logEvent('Page - View', {
		'Url': window.location.href
	});
});

const onLoad = () => {
	new ModalDialog();
};

$(function () {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad);
});